import type { EmailStarterTemplate } from '../types'

/**
 * "You forgot something" — friendly nudge + one big CTA back to checkout.
 * No guilt-tripping, no blaring discount; conversion nudges belong in a
 * follow-up email (Day 2), not the first one.
 */
export const abandonedCheckoutStarter: EmailStarterTemplate = {
    id: 'abandoned-checkout-friendly',
    label: 'Gentle reminder',
    description:
        'Friendly "still shopping?" email with a one-click link back to checkout.',
    icon: 'ShoppingCart',
    accent: '#2563eb',
    defaultSubject: 'You left something behind, {{ customerFirstName }}',
    defaultPreheader: 'Your cart is waiting — finish checkout in one click.',
    doc: {
        type: 'doc',
        content: [
            {
                type: 'heading',
                attrs: { level: 1, textAlign: 'left' },
                content: [{ type: 'text', text: 'Still thinking it over?' }],
            },
            {
                type: 'paragraph',
                content: [
                    { type: 'text', text: 'Hi ' },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'customerFirstName',
                            label: 'customerFirstName',
                            fallback: 'there',
                            required: false,
                        },
                    },
                    {
                        type: 'text',
                        text: ' — we saved your cart so you can pick up right where you left off. No pressure, we just wanted to make it easy.',
                    },
                ],
            },
            {
                type: 'emailButton',
                attrs: {
                    text: 'Return to checkout',
                    url: '{{ checkoutUrl }}',
                    align: 'left',
                    variant: 'filled',
                    radius: 'smooth',
                    bgColor: '#2563eb',
                    textColor: '#ffffff',
                },
            },
            { type: 'emailSpacer', attrs: { height: 12 } },
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        marks: [{ type: 'italic' }],
                        text: 'Questions about sizing, delivery, or anything else? Just hit reply — we read every message.',
                    },
                ],
            },
            { type: 'horizontalRule' },
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: 'Not interested anymore? No worries — this is the last nudge you will get about this cart.',
                    },
                ],
            },
        ],
    },
}
